// import React, { useState, useEffect } from 'react';
// import { Modal, Form, Button, Offcanvas } from 'react-bootstrap';
// import axios from 'axios';
// const ContactModal = ({
//     showModal,
//     handleClose,
//     handleSubmit,
//     formData,
//     handleInputChange,
//     errors,
//     isEdit,
// }) => {
//  console.log("Modal received showModal =", showModal);

//     // ✅ FIX: Only render modal when true
//     const [contactTypes, setContactTypes] = useState([]);
// useEffect(() => {
//   console.log("📘 ContactModal mounted, show =", showModal);
// }, [showModal]);

//     useEffect(() => {
//         if (formData.contact_type) {
//             fetchContactTypes(formData.contact_type);
//         }
//     }, [formData.contact_type]);
//     const backendUrl = process.env.REACT_APP_BACKEND_URL;

//     const API_URL = `${backendUrl}/api/contact-type`;
//     const fetchContactTypes = async (category) => {
//         try {
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;
//             const response = await axios.get(`${API_URL}?category=${category}`, {
//                 headers: { Authorization: `Bearer ${token}`,
//                 'Tenant-Origin': origin,
//             },
//                 skipLoader: true,

//             });
//             setContactTypes(response.data.data);
//         } catch (error) {
//             console.error("Error fetching contact types:", error);
//         }
//     };

//     const filteredContacts = contactTypes.filter(type => 
//         (type.category?.toLowerCase() || '') === (formData.contact_type?.toLowerCase() || '')
//     );
//         // if (!showModal) return null;

//     // return (
//     //     <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{width:'450px'}}>
//     //           {console.log("📗 Rendering Modal, show =", showModal)}

//     //         <Offcanvas.Header closeButton>
//     //             <Offcanvas.Title>{isEdit ? 'Edit Contact' : 'Add Contact'}</Offcanvas.Title>
//     //         </Offcanvas.Header>
//     //         <hr style={{ margin: 0 }} /><br/>
//     //         <Offcanvas.Body>
//     //             <Form>
//     //                 <Form.Group controlId="contactName" className='mb-3'>
//     //                     <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
//     //                     <Form.Control
//     //                         style={{ fontSize: "13px" }}
//     //                         type="text"
//     //                         name="name"
//     //                         value={formData?.name || ''}                            
//     //                          onChange={handleInputChange}
//     //                         className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
//     //                     />
//     //                     {errors.name && (
//     //                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>
//     //                     )}
//     //                 </Form.Group>

//     //                 <Form.Group controlId="contactEmail" className='mb-3'>
//     //                     <Form.Label style={{ fontSize: "13px" }}>Email</Form.Label>
//     //                     <Form.Control
//     //                         style={{ fontSize: "13px" }}
//     //                         type="email"
//     //                         name="email"
//     //                         value={formData?.email || ''}
//     //                         onChange={handleInputChange}
//     //                         className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
//     //                     />
//     //                     {errors.email && (
//     //                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.email}</div>
//     //                     )}
//     //                 </Form.Group>

//     //                 <Form.Group controlId="contactPhone" className='mb-3'>
//     //                     <Form.Label style={{ fontSize: "13px" }}>Phone</Form.Label>
//     //                     <Form.Control
//     //                         style={{ fontSize: "13px" }}
//     //                         type="text"
//     //                         name="phone"
//     //                         value={formData?.phone || ''}   
//     //                         onChange={handleInputChange}
//     //                         className={`form-control ${errors?.phone ? 'is-invalid' : ''}`}
//     //                     />
//     //                     {errors.phone && (
//     //                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.phone}</div>
//     //                     )}
//     //                 </Form.Group>

//     //                 <Form.Group controlId="position" className='mb-3'>
//     //                     <Form.Label style={{ fontSize: "13px" }}>Position</Form.Label>
//     //                     <Form.Control
//     //                         style={{ fontSize: "13px" }}
//     //                         type="text"
//     //                         name="position"
//     //                         value={formData?.position   || ''}
//     //                         onChange={handleInputChange}
//     //                         className="form-control"
//     //                     />
//     //                 </Form.Group>

//     //                 <Form.Group controlId="contact_type" className='mb-3'>
//     //                     <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
//     //                     <Form.Select
//     //                         style={{ fontSize: "13px" }}
//     //                         name="contact_type"
//     //                         value={formData?.contact_type || ''}
//     //                         onChange={handleInputChange}
//     //                     >
//     //                         <option value="">Select</option>
//     //                         <option value="internal">Internal</option>
//     //                         <option value="external">External</option>
//     //                     </Form.Select>
//     //                 </Form.Group>
//     //                 {formData.contact_type && (
//     //                     <Form.Group controlId="externalType" className="mb-3">
//     //                         <Form.Label style={{ fontSize: "13px" }}>Contact Type</Form.Label>
//     //                         <Form.Select
//     //                             style={{ fontSize: "13px" }}
//     //                             name="type_id"
//     //                             value={formData?.type_id || ""}
//     //                             onChange={handleInputChange}
//     //                         >
//     //                             <option value="">Select</option>
//     //                             {filteredContacts.map((type) => (
//     //                                 <option key={type.id} value={type.id}>{type.name}</option>
//     //                             ))}
//     //                         </Form.Select>
//     //                     </Form.Group>
//     //                 )}
//     //             </Form>
//     //             </Offcanvas.Body>
//     //             <div className="p-3 border-top  d-flex justify-content-end">
//     //                 <Button variant="secondary" onClick={handleClose} className="me-2">Close</Button>
//     //                 <Button variant="primary" onClick={handleSubmit}>Save</Button>
//     //             </div>
//     //     </Offcanvas>
//     // );

//  return (
//     <>
//         {showModal && (
//             <>
//             <div 
//                 className="modal-backdrop show"
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100%',
//                     height: '100%',
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     zIndex: 1040,
//                 }}
//                 onClick={handleClose}
//             />

//             {/* Right-side modal */}
//             <div 
//                 className="custom-right-modal"
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     right: 0,
//                     width: '450px',
//                     height: '100%',
//                     backgroundColor: 'white',
//                     zIndex: 1041,
//                     boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     transform: 'translateX(0)',
//                     transition: 'transform 0.3s ease-in-out'
//                 }}
//             >
//                 {/* Header */}
//                 <div className="modal-header" style={{
//                     padding: '1rem',
//                     borderBottom: '1px solid #dee2e6',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center'
//                 }}>
//                     <h5 className="modal-title mb-0">{isEdit ? 'Edit Contact' : 'Add Contact'}</h5>
//                     <button 
//                         type="button" 
//                         className="btn-close" 
//                         onClick={handleClose}
//                         style={{ border: 'none', background: 'transparent', fontSize: '1.2rem' }}
//                     >
//                         ×
//                     </button>
//                 </div>

//                 {/* Body */}
//                 <div className="modal-body" style={{
//                     flex: 1,
//                     overflow: 'auto',
//                     padding: '1rem'
//                 }}>
//                     <Form>
//                         <Form.Group controlId="contactName" className='mb-3'>
//                             <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="name"
//                                 value={formData?.name || ''}                            
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
//                             />
//                             {errors.name && (
//                                 <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>
//                             )}
//                         </Form.Group>

//                         <Form.Group controlId="contactEmail" className='mb-3'>
//                             <Form.Label style={{ fontSize: "13px" }}>Email</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="email"
//                                 name="email"
//                                 value={formData?.email || ''}
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
//                             />
//                             {errors.email && (
//                                 <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.email}</div>
//                             )}
//                         </Form.Group>

//                         <Form.Group controlId="contactPhone" className='mb-3'>
//                             <Form.Label style={{ fontSize: "13px" }}>Phone</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="phone"
//                                 value={formData?.phone || ''}   
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.phone ? 'is-invalid' : ''}`}
//                             />
//                             {errors.phone && (
//                                 <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.phone}</div>
//                             )}
//                         </Form.Group>

//                         <Form.Group controlId="position" className='mb-3'>
//                             <Form.Label style={{ fontSize: "13px" }}>Position</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="position"
//                                 value={formData?.position || ''}
//                                 onChange={handleInputChange}
//                                 className="form-control"
//                             />
//                         </Form.Group>

//                         <Form.Group controlId="contact_type" className='mb-3'>
//                             <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
//                             <Form.Select
//                                 style={{ fontSize: "13px" }}
//                                 name="contact_type"
//                                 value={formData?.contact_type || ''}
//                                 onChange={handleInputChange}
//                             >
//                                 <option value="">Select</option>
//                                 <option value="internal">Internal</option>
//                                 <option value="external">External</option>
//                             </Form.Select>
//                         </Form.Group>

//                         {formData.contact_type && (
//                             <Form.Group controlId="externalType" className="mb-3">
//                                 <Form.Label style={{ fontSize: "13px" }}>Contact Type</Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: "13px" }}
//                                     name="type_id"
//                                     value={formData?.type_id || ""}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select</option>
//                                     {contactTypes.map((type) => (
//                                         <option key={type.id} value={type.id}>{type.name}</option>
//                                     ))}
//                                 </Form.Select>
//                             </Form.Group>
//                         )}
//                     </Form>
//                 </div>

//                 {/* Footer */}
//                 <div className="modal-footer" style={{
//                     padding: '1rem',
//                     borderTop: '1px solid #dee2e6',
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     gap: '0.5rem'
//                 }}>
//                     <Button variant="secondary" onClick={handleClose}>Close</Button>
//                     <Button variant="primary" onClick={handleSubmit}>Save</Button>
//                 </div>
//                  </div>
//             </>
//         )}
//     </>
//  );

// export default ContactModal;


// import React, { useState, useEffect } from 'react';
// import { Form, Button } from 'react-bootstrap';
// import axios from 'axios';

// const ContactModal = ({
//     showModal,
//     handleClose,
//     handleSubmit,
//     formData,
//     handleInputChange,
//     errors,
//     isEdit,
// }) => {

//     console.log("Modal received showModal =", showModal);

//     const [contactTypes, setContactTypes] = useState([]);

//     useEffect(() => {
//         console.log("📘 ContactModal mounted: show =", showModal);
//     }, [showModal]);

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const API_URL = `${backendUrl}/api/contact-type`;

//     const fetchContactTypes = async (category) => {
//         try {
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${API_URL}?category=${category}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             setContactTypes(response.data.data);
//         } catch (error) {
//             console.error("Error fetching contact types:", error);
//         }
//     };

//     useEffect(() => {
//         if (formData.contact_type) {
//             fetchContactTypes(formData.contact_type);
//         }
//     }, [formData.contact_type]);

//     const filteredContacts = contactTypes.filter(type =>
//         (type.category?.toLowerCase() || '') ===
//         (formData.contact_type?.toLowerCase() || '')
//     );

//     return (
//         <>
//             {showModal && (
//                 <>

//                     <div
//                         className="modal-backdrop show"
//                         style={{
//                             position: 'fixed',
//                             top: 0,
//                             left: 0,
//                             width: '100%',
//                             height: '100%',
//                             backgroundColor: 'rgba(0,0,0,0.7)',
//                             zIndex: 9998,
//                             pointerEvents: 'none', // ✅ add this
//                         }}
//                     />


//                     <div
//                         className="custom-right-modal"
//                         onClick={(e) => e.stopPropagation()}
//                         style={{
//                             position: 'fixed',
//                             top: 70,
//                             right: 0,
//                             width: '450px',
//                             height: 'calc(100% - 120px)',
//                             backgroundColor: 'white',
//                             zIndex: 9999,
//                             display: 'flex',
//                             flexDirection: 'column',
//                             boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
//                             transform: 'translateX(0)',
//                             transition: 'transform 0.3s ease-in-out',
//                         }}
//                     >


//                         {/* ✅ Header */}
//                         <div
//                             className="modal-header"
//                             style={{
//                                 padding: '1rem',
//                                 borderBottom: '1px solid #dee2e6',
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                             }}
//                         >
//                             <h5 className="modal-title mb-0">
//                                 {isEdit ? 'Edit Contact' : 'Add Contact'}
//                             </h5>

//                             <button
//                                 type="button"
//                                 className="btn-close"
//                                 onClick={handleClose}
//                                 style={{
//                                     border: 'none',
//                                     background: 'transparent',
//                                     fontSize: '1.2rem',
//                                 }}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         {/* ✅ Body */}
//                         <div
//                             className="modal-body"
//                             style={{
//                                 flex: 1,
//                                 overflowY: 'auto',
//                                 padding: '1rem',
//                             }}
//                         >
//                             <Form>

//                                 {/* Name */}
//                                 <Form.Group controlId="contactName" className="mb-3">
//                                     <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
//                                     <Form.Control
//                                         style={{ fontSize: "13px" }}
//                                         type="text"
//                                         name="name"
//                                         value={formData?.name || ''}
//                                         onChange={handleInputChange}
//                                         className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
//                                     />
//                                     {errors.name && (
//                                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>
//                                             *{errors.name}
//                                         </div>
//                                     )}
//                                 </Form.Group>

//                                 {/* Email */}
//                                 <Form.Group controlId="contactEmail" className="mb-3">
//                                     <Form.Label style={{ fontSize: "13px" }}>Email</Form.Label>
//                                     <Form.Control
//                                         style={{ fontSize: "13px" }}
//                                         type="email"
//                                         name="email"
//                                         value={formData?.email || ''}
//                                         onChange={handleInputChange}
//                                         className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
//                                     />
//                                     {errors.email && (
//                                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>
//                                             *{errors.email}
//                                         </div>
//                                     )}
//                                 </Form.Group>

//                                 {/* Phone */}
//                                 <Form.Group controlId="contactPhone" className="mb-3">
//                                     <Form.Label style={{ fontSize: "13px" }}>Phone</Form.Label>
//                                     <Form.Control
//                                         style={{ fontSize: "13px" }}
//                                         type="text"
//                                         name="phone"
//                                         value={formData?.phone || ''}
//                                         onChange={handleInputChange}
//                                         className={`form-control ${errors?.phone ? 'is-invalid' : ''}`}
//                                     />
//                                     {errors.phone && (
//                                         <div className="invalid-feedback" style={{ fontSize: '12px' }}>
//                                             *{errors.phone}
//                                         </div>
//                                     )}
//                                 </Form.Group>

//                                 {/* Position */}
//                                 <Form.Group controlId="position" className="mb-3">
//                                     <Form.Label style={{ fontSize: "13px" }}>Position</Form.Label>
//                                     <Form.Control
//                                         style={{ fontSize: "13px" }}
//                                         type="text"
//                                         name="position"
//                                         value={formData?.position || ''}
//                                         onChange={handleInputChange}
//                                         className="form-control"
//                                     />
//                                 </Form.Group>

//                                 {/* Contact Type (Internal/External) */}
//                                 <Form.Group controlId="contact_type" className="mb-3">
//                                     <Form.Label style={{ fontSize: "13px" }}>Type</Form.Label>
//                                     <Form.Select
//                                         style={{ fontSize: "13px" }}
//                                         name="contact_type"
//                                         value={formData?.contact_type || ''}
//                                         onChange={handleInputChange}
//                                     >
//                                         <option value="">Select</option>
//                                         <option value="internal">Internal</option>
//                                         <option value="external">External</option>
//                                     </Form.Select>
//                                 </Form.Group>

//                                 {/* External Type Dropdown */}
//                                 {formData.contact_type && (
//                                     <Form.Group controlId="externalType" className="mb-3">
//                                         <Form.Label style={{ fontSize: "13px" }}>
//                                             Contact Type
//                                         </Form.Label>

//                                         <Form.Select
//                                             style={{ fontSize: "13px" }}
//                                             name="type_id"
//                                             value={formData?.type_id || ""}
//                                             onChange={handleInputChange}
//                                         >
//                                             <option value="">Select</option>
//                                             {filteredContacts.map((type) => (
//                                                 <option key={type.id} value={type.id}>
//                                                     {type.name}
//                                                 </option>
//                                             ))}
//                                         </Form.Select>
//                                     </Form.Group>
//                                 )}

//                             </Form>
//                         </div>

//                         {/* ✅ Footer */}
//                         <div
//                             className="modal-footer"
//                             style={{
//                                 padding: '1rem',
//                                 borderTop: '1px solid #dee2e6',
//                                 display: 'flex',
//                                 justifyContent: 'flex-end',
//                                 gap: '0.5rem',
//                             }}
//                         >
//                             <Button variant="secondary" onClick={handleClose}>
//                                 Close
//                             </Button>
//                             <Button variant="primary" onClick={handleSubmit}>
//                                 Save
//                             </Button>
//                         </div>

//                     </div>
//                 </>
//             )}
//         </>
//     );
// };

// export default ContactModal;


// import React, { useState, useEffect } from 'react';
// import { Form, Button } from 'react-bootstrap';
// import axios from 'axios';

// const ContactModal = ({
//     showModal,
//     handleClose,
//     handleSubmit,
//     formData,
//     handleInputChange,
//     errors,
//     isEdit,
// }) => {

//     const [contactTypes, setContactTypes] = useState([]);

//     useEffect(() => {
//         // Prevent body scroll when modal is open
//         if (showModal) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = 'unset';
//         }

//         return () => {
//             document.body.style.overflow = 'unset';
//         };
//     }, [showModal]);

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const API_URL = `${backendUrl}/api/contact-type`;

//     const fetchContactTypes = async (category) => {
//         try {
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${API_URL}?category=${category}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,
//             });

//             setContactTypes(response.data.data);
//         } catch (error) {
//             console.error("Error fetching contact types:", error);
//         }
//     };

//     useEffect(() => {
//         if (formData.contact_type && showModal) {
//             fetchContactTypes(formData.contact_type);
//         }
//     }, [formData.contact_type, showModal]);

//     const filteredContacts = contactTypes.filter(type =>
//         (type.category?.toLowerCase() || '') ===
//         (formData.contact_type?.toLowerCase() || '')
//     );

//     // Handle escape key to close modal
//     useEffect(() => {
//         const handleEscapeKey = (event) => {
//             if (event.key === 'Escape' && showModal) {
//                 handleClose();
//             }
//         };

//         if (showModal) {
//             document.addEventListener('keydown', handleEscapeKey);
//         }

//         return () => {
//             document.removeEventListener('keydown', handleEscapeKey);
//         };
//     }, [showModal, handleClose]);

//     if (!showModal) return null;

//     return (
//         <>
//             {/* Backdrop - Fixed positioning */}
//             <div
//                 className="modal-backdrop show"
//                 onClick={handleClose}
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100vw',
//                     height: '100vh',
//                     backgroundColor: 'rgba(0,0,0,0.7)',
//                     zIndex: 9998,
//                     cursor: 'pointer',
//                 }}
//             />

//             {/* Modal Container - Fixed positioning */}
//             <div
//                 className="custom-right-modal"
//                 onClick={(e) => e.stopPropagation()}
//                 style={{
//                     position: 'fixed',
//                     top: '0',
//                     right: '0',
//                     width: '450px',
//                     height: '100vh',
//                     backgroundColor: 'white',
//                     zIndex: 9999,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
//                 }}
//             >
//                 {/* Header - Always visible at top */}
//                 <div
//                     className="modal-header"
//                     style={{
//                         padding: '1rem',
//                         borderBottom: '1px solid #dee2e6',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         flexShrink: 0,
//                         backgroundColor: '#f8f9fa',
//                         height: '60px', // Fixed height
//                         minHeight: '60px', // Ensure minimum height
//                         position: 'relative',
//                         zIndex: 10,
//                     }}
//                 >
//                     <h5 className="modal-title mb-0" style={{ fontSize: '16px', fontWeight: '600' }}>
//                         {isEdit ? 'Edit Contact' : 'Add Contact'}
//                     </h5>

//                     <button
//                         type="button"
//                         className="btn-close"
//                         onClick={handleClose}
//                         style={{
//                             border: 'none',
//                             background: 'transparent',
//                             fontSize: '1.5rem',
//                             cursor: 'pointer',
//                             width: '35px',
//                             height: '35px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             borderRadius: '4px',
//                         }}
//                         onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
//                         onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
//                     >
//                         ×
//                     </button>
//                 </div>

//                 {/* Scrollable Body Area */}
//                 <div
//                     className="modal-body"
//                     style={{
//                         flex: 1,
//                         overflowY: 'auto',
//                         padding: '1rem',
//                         minHeight: 'calc(100vh - 120px)', // Calculate based on header+footer
//                     }}
//                 >
//                     <Form>
//                         {/* Name */}
//                         <Form.Group controlId="contactName" className="mb-3">
//                             <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>Name</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="name"
//                                 value={formData?.name || ''}
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
//                                 placeholder="Enter contact name"
//                             />
//                             {errors.name && (
//                                 <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
//                                     *{errors.name}
//                                 </div>
//                             )}
//                         </Form.Group>

//                         {/* Email */}
//                         <Form.Group controlId="contactEmail" className="mb-3">
//                             <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>Email</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="email"
//                                 name="email"
//                                 value={formData?.email || ''}
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.email ? 'is-invalid' : ''}`}
//                                 placeholder="Enter email address"
//                             />
//                             {errors.email && (
//                                 <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
//                                     *{errors.email}
//                                 </div>
//                             )}
//                         </Form.Group>

//                         {/* Phone */}
//                         <Form.Group controlId="contactPhone" className="mb-3">
//                             <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>Phone</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="phone"
//                                 value={formData?.phone || ''}
//                                 onChange={handleInputChange}
//                                 className={`form-control ${errors?.phone ? 'is-invalid' : ''}`}
//                                 placeholder="Enter phone number"
//                             />
//                             {errors.phone && (
//                                 <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
//                                     *{errors.phone}
//                                 </div>
//                             )}
//                         </Form.Group>

//                         {/* Position */}
//                         <Form.Group controlId="position" className="mb-3">
//                             <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>Position</Form.Label>
//                             <Form.Control
//                                 style={{ fontSize: "13px" }}
//                                 type="text"
//                                 name="position"
//                                 value={formData?.position || ''}
//                                 onChange={handleInputChange}
//                                 className="form-control"
//                                 placeholder="Enter position"
//                             />
//                         </Form.Group>

//                         {/* Contact Type (Internal/External) */}
//                         <Form.Group controlId="contact_type" className="mb-3">
//                             <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>Type</Form.Label>
//                             <Form.Select
//                                 style={{ fontSize: "13px" }}
//                                 name="contact_type"
//                                 value={formData?.contact_type || ''}
//                                 onChange={handleInputChange}
//                             >
//                                 <option value="">Select Type</option>
//                                 <option value="internal">Internal</option>
//                                 <option value="external">External</option>
//                             </Form.Select>
//                         </Form.Group>

//                         {/* External Type Dropdown */}
//                         {formData.contact_type && (
//                             <Form.Group controlId="externalType" className="mb-3">
//                                 <Form.Label style={{ fontSize: "13px", fontWeight: "500" }}>
//                                     Contact Type
//                                 </Form.Label>
//                                 <Form.Select
//                                     style={{ fontSize: "13px" }}
//                                     name="type_id"
//                                     value={formData?.type_id || ""}
//                                     onChange={handleInputChange}
//                                 >
//                                     <option value="">Select Contact Type</option>
//                                     {filteredContacts.map((type) => (
//                                         <option key={type.id} value={type.id}>
//                                             {type.name}
//                                         </option>
//                                     ))}
//                                 </Form.Select>
//                             </Form.Group>
//                         )}
//                     </Form>
//                 </div>

//                 {/* Footer - Always visible at bottom */}
//                 <div
//                     className="modal-footer"
//                     style={{
//                         padding: '1rem',
//                         borderTop: '1px solid #dee2e6',
//                         display: 'flex',
//                         justifyContent: 'flex-end',
//                         gap: '0.5rem',
//                         flexShrink: 0,
//                         backgroundColor: '#f8f9fa',
//                         height: '60px', // Fixed height
//                         minHeight: '60px', // Ensure minimum height
//                         position: 'relative',
//                         zIndex: 10,
//                     }}
//                 >
//                     <Button 
//                         variant="outline-secondary" 
//                         onClick={handleClose}
//                         style={{ fontSize: '13px', minWidth: '80px' }}
//                     >
//                         Close
//                     </Button>
//                     <Button 
//                         variant="primary" 
//                         onClick={handleSubmit}
//                         style={{ fontSize: '13px', minWidth: '80px' }}
//                     >
//                         {isEdit ? 'Update' : 'Save'}
//                     </Button>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default ContactModal;

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';

const ContactModalContent = ({
    showModal,
    handleClose,
    handleSubmit,
    formData,
    handleInputChange,
    errors,
    isEdit,
}) => {

    const [contactTypes, setContactTypes] = useState([]);

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => document.body.style.overflow = 'unset';
    }, [showModal]);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const API_URL = `${backendUrl}/api/contact-type`;

    const fetchContactTypes = async (category) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${API_URL}?category=${category}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setContactTypes(response.data.data);
        } catch (error) {
            console.error("Error fetching contact types:", error);
        }
    };

    useEffect(() => {
        if (formData.contact_type && showModal) {
            fetchContactTypes(formData.contact_type);
        }
    }, [formData.contact_type, showModal]);

    const filteredContacts = contactTypes.filter(type =>
        (type.category?.toLowerCase() || '') ===
        (formData.contact_type?.toLowerCase() || '')
    );

    // Escape key support
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape' && showModal) {
                handleClose();
            }
        };

        if (showModal) document.addEventListener('keydown', handleEscapeKey);
        return () => document.removeEventListener('keydown', handleEscapeKey);
    }, [showModal, handleClose]);

    if (!showModal) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="modal-backdrop show"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    zIndex: 99998,
                }}
            />

            {/* Modal */}
            <div
                className="custom-right-modal"
                onClick={(e) => e.stopPropagation()}
                style={{
                    position: 'fixed',
                    top: '0',
                    right: '0',
                    width: '450px',
                    height: '100vh',
                    backgroundColor: 'white',
                    zIndex: 99999,
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
                }}
            >
                {/* Header */}
                <div
                    className="modal-header"
                    style={{
                        padding: '1rem',
                        borderBottom: '1px solid #dee2e6',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#f8f9fa',
                        height: '60px',
                        zIndex: 10,
                    }}
                >
                    <h5 style={{ margin: 0 }}>
                        {isEdit ? 'Edit Contact' : 'Add Contact'}
                    </h5>

                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        style={{ cursor: 'pointer' }}
                    >
                        ×
                    </button>
                </div>

                {/* Scrollable Body */}
                <div
                    className="modal-body"
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '1rem',
                    }}
                >
                    {errors?.apiError && (
                        <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '12px' }}>
                            {errors.apiError}
                        </div>
                    )}
                    {errors?.general && (
                        <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '12px' }}>
                            {errors.general}
                        </div>
                    )}
                    <Form>

                        {/* Name */}
                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData?.name || ''}
                                onChange={handleInputChange}
                                className={errors?.name ? 'is-invalid' : ''}
                            />
                            {errors?.name && (
                                <div className="invalid-feedback d-block">
                                    *{errors.name}
                                </div>
                            )}
                        </Form.Group>

                        {/* Email */}
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={formData?.email || ''}
                                onChange={handleInputChange}
                                className={errors?.email ? 'is-invalid' : ''}
                            />
                            {errors?.email && (
                                <div className="invalid-feedback d-block">
                                    *{errors.email}
                                </div>
                            )}
                        </Form.Group>

                        {/* Phone */}
                        <Form.Group className="mb-3">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                                type="text"
                                name="phone"
                                value={formData?.phone || ''}
                                onChange={handleInputChange}
                                className={errors?.phone ? 'is-invalid' : ''}
                            />
                            {errors?.phone && (
                                <div className="invalid-feedback d-block">
                                    *{errors.phone}
                                </div>
                            )}
                        </Form.Group>

                        {/* Position */}
                        <Form.Group className="mb-3">
                            <Form.Label>Position</Form.Label>
                            <Form.Control
                                type="text"
                                name="position"
                                value={formData?.position || ''}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        {/* Type */}
                        <Form.Group className="mb-3">
                            <Form.Label>Type</Form.Label>
                            <Form.Select
                                name="contact_type"
                                value={formData?.contact_type || ''}
                                onChange={handleInputChange}
                            >
                                <option value="">Select</option>
                                <option value="internal">Internal</option>
                                <option value="external">External</option>
                            </Form.Select>
                        </Form.Group>

                        {/* External Contact Dropdown */}
                        {formData.contact_type && (
                            <Form.Group className="mb-3">
                                <Form.Label>Contact Type</Form.Label>
                                <Form.Select
                                    name="type_id"
                                    value={formData?.type_id || ""}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Contact Type</option>
                                    {filteredContacts.map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        )}

                    </Form>
                </div>

                {/* Footer */}
                <div
                    className="modal-footer"
                    style={{
                        padding: '1rem',
                        borderTop: '1px solid #dee2e6',
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '0.5rem',
                        height: '60px'
                    }}
                >
                    <Button variant="outline-secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {isEdit ? 'Update' : 'Save'}
                    </Button>
                </div>
            </div>
        </>
    );
};

// -------------------------
// PORTAL RENDER HERE
// -------------------------
const ContactModal = (props) => {
    return ReactDOM.createPortal(
        <ContactModalContent {...props} />,
        document.body
    );
};

export default ContactModal;
